export default (axios, path = '/team') => ({
  findAllForGame: async (gameId) => {
    return await axios.get(`${path}/game/${gameId}`)
  },
  save: async ({gameId, name}) => {
    return await axios.post(`${path}/game/${gameId}`, {name})
  },
  delete: async (teamId) => {
    return await axios.delete(`${path}/${teamId}`)
  },
  findAllUsersForTeam: async (teamId) => {
    return await axios.get(`${path}/${teamId}/users`)
  },
  findDetail: async (teamId) => {
    return await axios.get(`${path}/${teamId}?fetchUsers=true`)
  },
})
